module.exports = __webpack_public_path__ + "static/img/app-logo.4cbeca32.webp";